import { Box, Stack } from "@repo/ui/core";
import { motion } from "framer-motion";
import { SlideTitle } from "@components/SlideTitle";
import { ArchitectureDiagram } from "../components/ArchitectureDiagram";

type Props = {
  title: string;
  subtitle?: string;
};

export function ArchitectureSlide({ title, subtitle }: Props) {
  return (
    <Box w="100%" px="md" h="100%">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        style={{ height: "100%", display: "flex", flexDirection: "column" }}
      >
        <Stack gap="md" style={{ flex: 1, minHeight: 0 }}>
          <SlideTitle title={title} subtitle={subtitle} />

          <Box style={{ flex: 1, minHeight: 0 }}>
            <ArchitectureDiagram />
          </Box>
        </Stack>
      </motion.div>
    </Box>
  );
}
